import { ProvidersCreate } from "./ProvidersCreate";
import { ProvidersList } from "./ProvidersList";
import ProvidersShow from "./ProvidersShow";
import ProvidersEdit from "./ProvidersEdit";

export const providers = {
  list: ProvidersList,
  create: ProvidersCreate,
  edit: ProvidersEdit,
  show: ProvidersShow,
};
